var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-tabs",
    {
      attrs: { color: "secondary" },
      model: {
        value: _vm.report,
        callback: function($$v) {
          _vm.report = $$v
        },
        expression: "report"
      }
    },
    [
      _c("q-tab", {
        attrs: { slot: "title", name: "general", label: _vm.$t("general") },
        slot: "title"
      }),
      _vm.client_selected.has_courses
        ? _c("q-tab", {
            attrs: { slot: "title", name: "courses", label: _vm.$t("online") },
            slot: "title"
          })
        : _vm._e(),
      _vm.client_selected.has_live_classes
        ? _c("q-tab", {
            attrs: {
              slot: "title",
              name: "live_classes",
              label: _vm.$t("live_classes")
            },
            slot: "title"
          })
        : _vm._e(),
      _vm.client_selected.has_presential
        ? _c("q-tab", {
            attrs: {
              slot: "title",
              name: "presential",
              label: _vm.$t("presential")
            },
            slot: "title"
          })
        : _vm._e(),
      _vm.client_selected.has_trails
        ? _c("q-tab", {
            attrs: { slot: "title", name: "trails", label: _vm.$t("trail") },
            slot: "title"
          })
        : _vm._e(),
      _vm.client_selected.has_webcasts
        ? _c("q-tab", {
            attrs: { slot: "title", name: "webcast", label: _vm.$t("webcast") },
            slot: "title"
          })
        : _vm._e(),
      _vm.client_selected.has_podcasts
        ? _c("q-tab", {
            attrs: {
              slot: "title",
              name: "podcasts",
              label: _vm.$t("podcasts")
            },
            slot: "title"
          })
        : _vm._e(),
      _c("q-tab-pane", { attrs: { name: "general" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [_c("general", { attrs: { show_report: _vm.show_report } })],
            1
          )
        ])
      ]),
      _c("q-tab-pane", { attrs: { name: "courses" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-tabs",
                {
                  attrs: { color: "primary" },
                  model: {
                    value: _vm.type_courses,
                    callback: function($$v) {
                      _vm.type_courses = $$v
                    },
                    expression: "type_courses"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "results",
                      label: _vm.$t("results")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "classes",
                      label: _vm.$t("classes")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "games",
                      label: _vm.$t("games")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "tests",
                      label: _vm.$t("tests")
                    },
                    slot: "title"
                  }),
                  _vm.client_selected.use_training_subscription
                    ? _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "registrations",
                          label: _vm.$t("registrations")
                        },
                        slot: "title"
                      })
                    : _vm._e(),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "available",
                      label: _vm.$t("availables")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "results" } },
                    [_c("courses-results")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "classes" } },
                    [_c("courses-classes")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "games" } },
                    [_c("courses-games")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "tests" } },
                    [_c("courses-tests")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "registrations" } },
                    [_c("courses-registrations")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "available" } },
                    [
                      _vm.client_selected.use_training_subscription
                        ? _c("courses-available")
                        : _c("courses-available-false")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("q-tab-pane", { attrs: { name: "live_classes" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-tabs",
                {
                  attrs: { color: "primary" },
                  model: {
                    value: _vm.type_live,
                    callback: function($$v) {
                      _vm.type_live = $$v
                    },
                    expression: "type_live"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "results",
                      label: _vm.$t("results")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "participations",
                      label: _vm.$t("participations")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "tests",
                      label: _vm.$t("tests")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "registrations",
                      label: _vm.$t("registrations")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "available",
                      label: _vm.$t("availables")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "results" } },
                    [_c("live-classes-results")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "participations" } },
                    [_c("live-classes-participations")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "tests" } },
                    [_c("live-classes-tests")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "registrations" } },
                    [_c("live-classes-registrations")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "available" } },
                    [_c("live-classes-available")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("q-tab-pane", { attrs: { name: "presential" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-tabs",
                {
                  attrs: { color: "primary" },
                  model: {
                    value: _vm.type_presential,
                    callback: function($$v) {
                      _vm.type_presential = $$v
                    },
                    expression: "type_presential"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "results",
                      label: _vm.$t("results")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "events",
                      label: _vm.$t("events")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "tests",
                      label: _vm.$t("tests")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "scheduled",
                      label: _vm.$t("pending_plural")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "registrations",
                      label: _vm.$t("registrations")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "available",
                      label: _vm.$t("availables")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "results" } },
                    [_c("presential-results")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "events" } },
                    [_c("presential-events")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "tests" } },
                    [_c("presential-tests")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "scheduled" } },
                    [_c("presential-scheduled")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "registrations" } },
                    [_c("presential-registrations")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "available" } },
                    [_c("presential-available")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("q-tab-pane", { attrs: { name: "trails" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-tabs",
                {
                  attrs: { color: "primary" },
                  model: {
                    value: _vm.type_trails,
                    callback: function($$v) {
                      _vm.type_trails = $$v
                    },
                    expression: "type_trails"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "results",
                      label: _vm.$t("results")
                    },
                    slot: "title"
                  }),
                  _vm.client_selected.use_trail_subscription
                    ? _c("q-tab", {
                        attrs: {
                          slot: "title",
                          name: "registrations",
                          label: _vm.$t("registrations")
                        },
                        slot: "title"
                      })
                    : _vm._e(),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "available",
                      label: _vm.$t("availables")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "results" } },
                    [_c("trails-results")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "registrations" } },
                    [_c("trails-registrations")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "available" } },
                    [
                      _vm.client_selected.use_trail_subscription
                        ? _c("trails-available")
                        : _c("trails-available-false")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("q-tab-pane", { attrs: { name: "webcast" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-tabs",
                {
                  attrs: { color: "primary" },
                  model: {
                    value: _vm.type_webcast,
                    callback: function($$v) {
                      _vm.type_webcast = $$v
                    },
                    expression: "type_webcast"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "results",
                      label: _vm.$t("results")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "participations",
                      label: _vm.$t("participations")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "tests",
                      label: _vm.$t("tests")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "registrations",
                      label: _vm.$t("registrations")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "available",
                      label: _vm.$t("availables")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "results" } },
                    [_c("webcast-results")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "participations" } },
                    [_c("webcast-participations")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "tests" } },
                    [_c("webcast-tests")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "registrations" } },
                    [_c("webcast-registrations")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "available" } },
                    [_c("webcast-available")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("q-tab-pane", { attrs: { name: "podcasts" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(
                "q-tabs",
                {
                  attrs: { color: "primary" },
                  model: {
                    value: _vm.type_podcast,
                    callback: function($$v) {
                      _vm.type_podcast = $$v
                    },
                    expression: "type_podcast"
                  }
                },
                [
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "results",
                      label: _vm.$t("results")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "favorites",
                      label: _vm.$t("favorites")
                    },
                    slot: "title"
                  }),
                  _c("q-tab", {
                    attrs: {
                      slot: "title",
                      name: "available",
                      label: _vm.$t("availables")
                    },
                    slot: "title"
                  }),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "results" } },
                    [_c("podcasts-results")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "favorites" } },
                    [_c("podcasts-favorites")],
                    1
                  ),
                  _c(
                    "q-tab-pane",
                    { attrs: { name: "available" } },
                    [_c("podcasts-available")],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }